import { IRapportUtdelning } from '../../Queries/AnalysutdelningQuery/AnalysutdelningQuery';
import { equals } from 'ramda';

export const getChangedAnalyser = (
  analyser: IRapportUtdelning[],
  originalAnalyser: IRapportUtdelning[]
): IRapportUtdelning[] => {
  const result: IRapportUtdelning[] = [];

  analyser.forEach(analys => {
    const original = originalAnalyser.find(o => o.id === analys.id);
    if (original && !equals(analys, original)) {
      result.push(analys);
    }
  });

  return result;
};

export const findStartAnalys = (
  analyser: IRapportUtdelning[]
): IRapportUtdelning | null => {
  const startAnalys = analyser.find(a => a.startAnalysForNewUser);
  if (startAnalys) {
    return startAnalys;
  }

  return null;
};

export const filterAnalyser = (
  analyser: IRapportUtdelning[],
  search: string,
  showAvailable: boolean,
  showNotAvailable: boolean,
  showVisible: boolean,
  showNotVisible: boolean,
  isGas: boolean
): IRapportUtdelning[] => {
  return analyser.filter(a => {
    if (!showAvailable && a.availableForAnalys) {
      return false;
    }

    if (!showNotAvailable && !a.availableForAnalys) {
      return false;
    }

    if (!showVisible && a.defaultForNewUser) {
      return false;
    }

    if (!showNotVisible && !a.defaultForNewUser) {
      return false;
    }

    const analysObligatoriskForRoleNames = isGas
      ? a.obligatoriskGas.map(role => role.name.trim().toLowerCase())
      : [];

    const trimedSearch = search.trim().toLowerCase();

    return (
      a.name.trim().toLowerCase().includes(trimedSearch) ||
      a.category.trim().toLowerCase().includes(trimedSearch) ||
      a.type.trim().toLowerCase().includes(trimedSearch) ||
      analysObligatoriskForRoleNames.some(roleName =>
        roleName.includes(trimedSearch)
      )
    );
  });
};
